export default {
  "content": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["第一个页面内容"])}
}